import { IconButton, Stack } from "@mui/material";
import { CloseIcon, RED_WARNING_ICON } from "Assets/icons";
import { GreenButton } from "Components/button/index";
import { Link } from "Components/link";
import Row from "Components/Row";
import { SmText, TextMd } from "Components/Text";
import { ERROR_CODES } from "constants/code";
import { COLORS } from "constants/layout";
import { PATHS } from "constants/routes";
import { useTranslation } from "hooks/useTranslation";
import React from "react";

type Props = {
  onClose?: () => void;
  type?: string;
};

const BlockSpamInquiryPopup = ({ onClose, type }: Props) => {
  const t = useTranslation();
  return (
    <Stack p={2} spacing={1}>
      <Row justifyContent="space-between">
        <Row spacing={1}>
          <img src={RED_WARNING_ICON} alt="icon" width={30} height={30} loading="lazy"/>
          <TextMd>{t("limit_inquiry")}</TextMd>
        </Row>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Row>

      <SmText color={COLORS.gray[500]}>{t("limit_inquiry_desc")}</SmText>

      <Row justifyContent="flex-end">
        {type === ERROR_CODES.REACH_OUT_LIMIT_REQUIRED_VERIFIED && (
          <Link to={PATHS.membership} openNewTab>
            <SmText color={COLORS.blue[700]}>
              {t("verify_business_account")}
            </SmText>
          </Link>
        )}
        <GreenButton onClick={onClose}>{t("go_back")}</GreenButton>
      </Row>
    </Stack>
  );
};

export default BlockSpamInquiryPopup;
